<template>
    <div>

        <v-row>
            <v-col class="text-center">
            <span  style="font-size:20px;font-weight:bold;">
                PRENOTAZIONE COMPLETATA
                <br><span class="service">Ti aspettiamo!!</span></span>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
            <p class="text-center">Ecco il riepilogo del tuo appuntamento,<br> prendi nota!</p>
            </v-col>
        </v-row>

        <v-card style="background-color:rgb(64, 211, 230)">
            <v-card-title>Appuntamento</v-card-title>
            <v-card-text>
                <div>
                    <strong>NOME:</strong> {{name}}
                </div>
                <div>
                    <strong>TELEFONO:</strong> {{phone}}
                </div>
                
                <div>
                    <strong>SERVIZIO:</strong> {{service.name}}
                </div>
                <div style="text-transform:capitalize">
                    <strong>DATA:</strong> {{date | moment("dddd D MMMM ")}}
                </div>
                <div>
                    <strong>ORARIO:</strong> {{hour}}
                </div>
            </v-card-text>
        </v-card>

    </div>
</template>

<script>

import { store } from "../store"


export default {
  name: 'Confirm',

  components: {
  },
  data: () => ({
    step:4,
    service: store.service, 
    date: store.date,
    hour: store.hour,
    name: store.name,
    phone: store.phone,
    completed: store.completed
  }),
  mounted(){
      if(!this.completed){
          this.$router.push("/");
      }
  },
  methods:{
  }
};
</script>

<style scoped>
.service{
  color:rgb(64, 211, 230);
}
</style>